import { useQuery } from '@tanstack/react-query';
import { ApiCompanyAndContactsRepository } from 'services/company-and-contacts/ApiCompanyAndContactsRepository';
import { QueryKeys } from 'utils/queryKeys';
import type { CrmCompany } from 'services/company-and-contacts/mappers';

const EMPTY_CRM_COMPANIES: CrmCompany[] = [];

export const useSearchCrmCompanies = ({ searchTerm, enabled = true }: { searchTerm?: string; enabled?: boolean } = {}) => {
  const { data, isLoading, isError } = useQuery({
    queryKey: QueryKeys.searchCrmCompanies(searchTerm),
    queryFn: () => ApiCompanyAndContactsRepository.searchCrmCompanies({ searchTerm }),
    enabled,
  });
  return { crmCompanies: data ?? EMPTY_CRM_COMPANIES, isLoading, isError };
};
